import enumeration from "./enumeration";

const ExternalPaymentVoidStatus = {
    Success: "SUCCESS",
    Failed: "FAILED"
};

export default enumeration(ExternalPaymentVoidStatus);